type EventEmitOptions = {
  reconnect?: boolean
}

type EventCallback<T = any> = (
  data: T,
  options?: EventEmitOptions,
) => void | Promise<void>
type EventMap = Record<string, EventCallback[]>

class EventBus<Events extends Record<string, any>> {
  private events: EventMap = {}

  on<K extends keyof Events>(event: K, callback: EventCallback<Events[K]>) {
    const eventName = event as string
    if (!this.events[eventName]) {
      this.events[eventName] = []
    }
    this.events[eventName].push(callback)
    return () => this.off(event, callback)
  }

  off<K extends keyof Events>(event: K, callback: EventCallback<Events[K]>) {
    const eventName = event as string
    if (!this.events[eventName]) return

    this.events[eventName] = this.events[eventName].filter(
      (cb) => cb !== callback,
    )
  }

  emit<K extends keyof Events>(
    event: K,
    data: Events[K],
    options?: EventEmitOptions,
  ) {
    const eventName = event as string
    if (!this.events[eventName]) return
    this.events[eventName].forEach((callback) => {
      try {
        void callback(data, options)
      } catch (e) {
        if (process.env.ENV === 'DEV')
          console.error(`EventBus handler error for "${eventName}":`, e)
      }
    })
  }
}

export default EventBus
